import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription } from 'rxjs';
import {
  GsEventSelectorComponent,
  SelectionMeta,
} from 'src/app/shared/features/event-selector/gs-event-selector.component';
import { UtilsService } from 'src/app/private/services/utils.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { Upgrade } from '../../models/upgrade.model';
import { UpgradeService } from '../../services/upgrade.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  imports: [
    BoDialogComponent,
    ButtonComponent,
    FormsModule,
    GsEventSelectorComponent,
  ],
})
export class EditComponent implements OnInit {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  utils = inject(UtilsService);
  private upgradeService = inject(UpgradeService);

  @ViewChild(GsEventSelectorComponent)
  eventSelector: GsEventSelectorComponent;

  @Input({ required: true }) item: Upgrade;
  private subscriptions: Array<Subscription>;
  public selectedEventIds: number[] = [];
  public hashValidator = {
    name: false,
    description: false,
    goal: false,
    minSeatsToShow: false,
  };
  public isAllEventsSelected = false;

  constructor() {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    this.selectedEventIds = this.item.events?.map(e => e.id) || [];
  }

  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm() {
    if (this.checkInputs(this.item)) return;
    const update$ = this.upgradeService
      .update$(this.item, this.selectedEventIds ?? [])
      .subscribe({
        next: response => {
          this.onDismiss('success');
        },
        error: err => {
          console.log(err);
        },
      });
    this.subscriptions.push(update$);
  }

  public onEventSelectionChange(ids: number[]) {
    this.selectedEventIds = ids;
  }

  public onEventSelectionMeta(meta: SelectionMeta) {
    this.isAllEventsSelected = meta.isAllSelected;
  }

  public onSelectAllEventsChange(event: any) {
    this.eventSelector.selectAll(event.target.checked);
  }

  private checkInputs(instance: Upgrade): boolean {
    let hasErrors = false;
    Object.keys(this.hashValidator).forEach(value => {
      this.hashValidator[value] = false;
    });
    if (this.utils.isEmpty(instance.name)) {
      this.hashValidator.name = true;
      hasErrors = true;
    }
    if (this.utils.isEmpty(instance.description)) {
      this.hashValidator.description = true;
      hasErrors = true;
    }
    if (instance.minSeatsToShow <= 0) {
      this.hashValidator.minSeatsToShow = true;
      hasErrors = true;
    }
    if (instance.goal <= 0) {
      this.hashValidator.goal = true;
      hasErrors = true;
    }

    return hasErrors;
  }
}
